// cambioServiceSchema.tsx
import * as yup from 'yup';


const onlyLetters =  /^[a-zA-Z0-9áéíóúÁÉÍÓÚñÑ\s.,:;()\-_/]+$/;
export const cambioServiceSchema = yup.object({
   titulo: yup
    .string()
    .required("Título requerido")
    .matches(onlyLetters, "Solo letras y espacios"),

  descripcion: yup
    .string()
    .required('La descripción es obligatoria')
    .matches(
      /^[A-Za-zÁÉÍÓÚáéíóúÑñ0-9.,\s]+$/,
      'Solo se permiten letras, números, espacios, puntos, comas y caracteres con tilde'
    ),

  prioridad: yup.string().required(),
  impacto: yup.string().required(),
  riesgo: yup.string().required(),
  tipoCambio: yup.string().required(),
  solicitante: yup.string().required("El solicitante es obligatorio"),

 areasAfectas: yup.array().of(yup.string()).min(1, 'Selecciona al menos un área'),

 fechaProgramada: yup
  .string()
  .required('La fecha programada es obligatoria')
  .test(
    'fecha-valida',
    'La fecha programada no puede ser menor a la fecha actual',
    (value) => {
      if (!value) return false;
      const hoy = new Date();
      const string_date =[
        hoy.getFullYear(),
        String(hoy.getMonth()+1).padStart(2, '0'),
        String(hoy.getDate()).padStart(2, '0'),
      ].join('-');

      return value >= string_date;
    }
  ),
  horaProgramada: yup.string().required(),
 duracion: yup.number().typeError('Selecciona una duración').required(),

  serviciosAfectados: yup.array().of(
    yup.object({
      tiempoAfectacion: yup.string().required(),
      clienteAfectado: yup.string().required(),
      servicio: yup.string().required(),
    })
  ),

  planAccion: yup.array().of(
    yup.object({
      accion: yup
        .string()
        .required()
        .matches(onlyLetters, "Solo letras y espacios"),

      responsable: yup.string().required(),
      fecha: yup.string().required(),

      observacion: yup
        .string()
        .required()
        .matches(onlyLetters, "Solo letras y espacios"),
    })
  ),

  riesgos: yup.array().of(
    yup.object({
      descripcion: yup
        .string()
        .required()
        .matches(onlyLetters, "Solo letras y espacios"),

      impacto: yup.string().required(),
      probabilidad: yup.string().required(),
      tipoRiesgo: yup.string().required(),

      accionContingencia: yup
        .string()
        .required()
        .matches(onlyLetters, "Solo letras y espacios"),
    })
  ),

  rollbackActividades: yup.array().of(
    yup.object({
      actividad: yup
        .string()
        .required()
        .matches(onlyLetters, "Solo letras y espacios"),

      duracion: yup.string().required(),
      responsable: yup.string().required(),
    })
  ),

 aprobadores: yup.array().of(
  yup.object({
      areaId: yup.string().required('Selecciona un área'),
      aprobadorId: yup.number()
        .typeError('Selecciona un aprobador')
        .required('Selecciona un aprobador'),
    })
  ).min(1, 'Agrega al menos un aprobador'),

  responsableIds: yup.array().of(yup.string()),
  notificacionIds: yup.array().of(yup.string())

});